import { createSlice } from '@reduxjs/toolkit';
import { UpdateRole } from 'helpers/api-calls/role-calls';

const rolesSlice = createSlice({
  name: 'roles',
  initialState: {
    data: [],
    loading: true,
  },
  reducers: {
      hydrateRoles: (state, action) => {
        state.data = action.payload;
        state.loading = false;
      },
      appendRole: (state, action) => {
        state.data = state.data.concat(action.payload);
        state.loading = false;
      },
      removeRole: (state, action) => {
        const result =  state.data.filter((tag) => tag.id !== action.payload.tagId);
        console.log(JSON.stringify(result));
        state.data = result;
      },
      updateRole: (state, action) => {
        const result = state.data.map((tag) => tag.id === action.payload.id? action.payload : tag);
        state.data = result;
      }
  },
});

export default rolesSlice;
